/**
 * Shared utilities for meter data processing across the matrikel-page feature.
 */

const METER_TYPES = ['power', 'water', 'heat'];

/**
 * Get the canonical meter ID from a meter object.
 * Normalizes across UnitId, MeteringPointId, and ReMoniUnitId.
 */
export const getMeterId = (meter) =>
  meter?.UnitId || meter?.MeteringPointId || meter?.ReMoniUnitId || null;

/**
 * Get a display address from a meter object, normalizing field name variations.
 */
export const getMeterDisplayAddress = (meter) =>
  meter?.Address || meter?.address || meter?.main_address || '-';

/**
 * Determine the meter type from a meter object.
 */
export const getMeterTypeFromMeter = (meter) => {
  if (meter?.type) return meter.type;
  if (meter?.AnalysisType) return meter.AnalysisType;
  return 'power';
};

/**
 * Process a raw meter_list array into flat meter objects with type annotation.
 * @param {Array} meterList - Raw meter_list from API (each item has .metadata and .analysis)
 * @param {string} type - 'power' | 'water' | 'heat'
 * @param {Object} [extraFields] - Additional fields to spread onto each meter
 * @returns {Array} Processed meter objects
 */
export const processMeterList = (meterList, type, extraFields = {}) => {
  if (!Array.isArray(meterList)) return [];

  return meterList
    .filter((m) => m?.metadata && getMeterId(m.metadata))
    .map((m) => ({
      ...m.analysis,
      ...m.metadata,
      // Ensure display_name comes from metadata (DisplayName) rather than stale analysis data
      display_name:
        m.metadata.DisplayName || m.metadata.Name || m.analysis?.display_name,
      id: `${type}_${getMeterId(m.metadata)}`,
      type,
      ...extraFields,
    }));
};

export { METER_TYPES };
